import { gql } from 'urql';
import {
  BusinessFragment,
  CashAccountFragment,
  InvestmentFragment,
  LoanFragment,
  MonetaryAmountFragment,
  RealEstateFragment,
} from './fragments';
import { GraphQLClient } from 'graphql-request';
import { QueryBtDetailsArgsWithDirectives } from './types';
import { Query } from '../generated/graphql';

const btDetailsQuery = gql`
  ${MonetaryAmountFragment}
  ${InvestmentFragment}
  ${BusinessFragment}
  ${LoanFragment}
  ${CashAccountFragment}
  ${RealEstateFragment}
  query BtDetails(
    $householdID: ID!
    $includeScore: Boolean!
    $includeTotalBusinessEquity: Boolean!
    $includeAnnualExpenses: Boolean!
    $includeBusinesses: Boolean!
    $includePrivateStock: Boolean!
    $includeTotalPrivateStock: Boolean!
    $includeTotalBusinessValue: Boolean!
    $includeTotalBusinessDebt: Boolean!
  ) {
    btDetails(householdID: $householdID) {
      bt @include(if: $includeScore)
      totalBusinessEquity @include(if: $includeTotalBusinessEquity) {
        ...MonetaryAmountFragment
      }
      annualExpenses @include(if: $includeAnnualExpenses) {
        ...MonetaryAmountFragment
      }
      businesses @include(if: $includeBusinesses) {
        business {
          ...BusinessFragment
        }
        loans {
          ...LoanFragment
        }
        ownedValue {
          ...MonetaryAmountFragment
        }
        ownedDebt {
          ...MonetaryAmountFragment
        }
        totalOwnedEquity {
          ...MonetaryAmountFragment
        }
        ownedCashAccounts {
          ...CashAccountFragment
        }
        totalOwnedCashAccounts {
          ...MonetaryAmountFragment
        }
        ownedQualifiedInvestments {
          ...InvestmentFragment
        }
        totalOwnedQualifiedInvestments {
          ...MonetaryAmountFragment
        }
        ownedNonQualifiedInvestments {
          ...InvestmentFragment
        }
        totalOwnedNonQualifiedInvestments {
          ...MonetaryAmountFragment
        }
        ownedRealEstate {
          ...RealEstateFragment
        }
        totalOwnedRealEstate {
          ...MonetaryAmountFragment
        }
      }
      privateStock @include(if: $includePrivateStock) {
        ...InvestmentFragment
      }
      totalPrivateStock @include(if: $includeTotalPrivateStock) {
        ...MonetaryAmountFragment
      }
      totalBusinessValue @include(if: $includeTotalBusinessValue) {
        ...MonetaryAmountFragment
      }
      totalBusinessDebt @include(if: $includeTotalBusinessDebt) {
        ...MonetaryAmountFragment
      }
    }
  }
`;

export const getBtDetails = async (
  client: GraphQLClient,
  args: QueryBtDetailsArgsWithDirectives
) => {
  return (
    await client.request<
      Pick<Query, 'btDetails'>,
      QueryBtDetailsArgsWithDirectives
    >(btDetailsQuery, args)
  ).btDetails;
};
